import { isIOS } from 'react-device-detect';
import { downloadAppURL } from '../../constants/appURL/downloadAppURL.constant';

export const getAppURL = (): string | undefined => {
  if (isIOS) {
    return downloadAppURL.ios;
  }
  return downloadAppURL.android;
};
